import { useRequest } from 'ahooks';
import { Options } from 'ahooks/lib/useRequest/src/types';
import { AxiosResponse } from 'axios';
import { StringifiableRecord } from 'query-string';

import { apiGet } from 'api';

import { checkSessionAction } from 'stores';
import { useGetHeaders } from 'hooks';
import { addQueryParamsToURL } from 'utils';

import { IApiHookRequestParams, TResponse } from 'types';

export const useGetRequest = <R>({
  url,
  options,
  baseURL,
  queryParams,
}: IApiHookRequestParams<R, StringifiableRecord>) => {
  const headers = useGetHeaders();

  const { data, ...rest } = useRequest<AxiosResponse<R>, [StringifiableRecord]>(
    () => {
      checkSessionAction();

      const urlWithParams = addQueryParamsToURL(url as string, queryParams);

      return apiGet({ url: urlWithParams, baseURL, headers });
    },
    options as Options<AxiosResponse<R>, [StringifiableRecord]>,
  );

  return {
    ...rest,
    data: data?.data,
  } as TResponse<R, StringifiableRecord>;
};
